/**************************************************
 * Nombre:       Seccion_Depositos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Tabla_Filtro from "../../Modulo_Tabla_2025/Componentes/Tabla_Filtro";
import {
    CASILLA_ESTADO,
    CASILLA_FECHA_DATOS,
    CASILLA_MONEDA,
    CASILLA_TEXTO
} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import React, {useContext, useEffect, useState} from "react";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import {ManageSearch} from "@mui/icons-material";
import Dialogo_Deposito from "../Dialogos/Dialogo_Deposito";
import {ESTADOSDEPOSITOS} from "../../Constantes";
import Dialogo_Deposito_Ver from "../Dialogos/Dialogo_Deposito_Ver";
import {where} from "firebase/firestore";
import {formatoMonedaTabla} from "../../Modulo_Tabla_2025/Utilidades/formatoMonedaTabla";
import {useObtenerColleccionTabla2025Wheres} from "../../Servicios/BD/useObtenerColleccionTabla2025Wheres";
import {usuarioContext} from "../../App";
import {obtenerSaldo} from "../../CodNegocio/Saldos/obtenerSaldo";

const Seccion_Depositos = () => {
    const cData = useContext(usuarioContext)
    const [totalDepositos, setTotalDepositos] = useState(0);
    const [wheres, setWherees] = useState([where('idUsuario', '==', cData.usuario.id)]);
    const {
        props,
        setData,
        setNumeroFilas,
        cargarNuevamente
    } = useObtenerColleccionTabla2025Wheres({coleccion: 'depositos', wheres: wheres})
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Deposito,
        titulo: 'Detalles Deposito',
        realizado: cargarNuevamente
    })
    const {Dialogo: DialogoVer, abrir: abrirVer} = useDialogo({
        Componente: Dialogo_Deposito_Ver,
        titulo: 'Detalles Deposito',
        realizado: cargarNuevamente
    })

    const click = (id, data) => {

        switch (id) {
            case 'detalles':
                abrirVer(data)
                break
        }
    }


    useEffect(() => {
        obtenerSaldo({idUsuario: cData.usuario.id}).then(res => {
            setTotalDepositos(res)
        })
    }, [cData])
    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px'}}
                spacing={3}
            >

                <Dialogo/>

                <DialogoVer/>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Tabla_Filtro
                        nombre={`Saldo Actual: ${formatoMonedaTabla(totalDepositos)}`}
                        descripcion={`${props.numeroFilas} en base de datos`}
                        filtros={filtros}
                        datosCabecera={datosCabecera}
                        {...props}
                        clickAgregar={abrir}
                        botonesData={botonesData}
                        clickData={click}
                        textoAgregar={'Nuevo Deposito'}
                        // funcionBuscar={funcionBuscar}
                        //  botones={[]}
                    />
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Seccion_Depositos

const filtros = [
    {
        nombre: 'Nombre',
        direccion: 'asc',
        propiedad: 'nombre'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    },
]

const datosCabecera = [
    {
        nombre: 'Valor',
        direccion: 'left',
        propiedades: ['consecutivo', 'tipo'],
        fecha: 'fecha',
        tipo: CASILLA_FECHA_DATOS
    },
    {
        nombre: 'Valor',
        direccion: 'left',
        propiedad: 'valor',
        tipo: CASILLA_MONEDA
    },
    {
        nombre: 'Mensaje',
        direccion: 'left',
        propiedad: 'mensaje',
        tipo: CASILLA_TEXTO
    },
    {
        nombre: 'Estado',
        direccion: 'right',
        propiedad: 'estado',
        tipo: CASILLA_ESTADO,
        estados: ESTADOSDEPOSITOS
    },

]

const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    }
]